import {FC, ReactElement, useContext, useState} from 'react'
import {GlobalContext} from './ctx/GlobalContext'
import {Trans, useTranslation} from 'react-i18next'
import SVGIcon from './SVGIcon'

export type ICallbackFunction = () => void

const InfoBox: FC<{
    title: ReactElement | string
    onCloseCallback?: ICallbackFunction
    sticky?: boolean
}> = ({title, onCloseCallback, sticky = false}) => {
    const {t} = useTranslation()

    const [hidden, setHidden] = useState<boolean>(false)
    const handleClickCloseBtn = (): void => {
        if (onCloseCallback) {
            onCloseCallback()
        }

        setHidden(!hidden)
    }

    return (
        <div
            className={
                'info-box' +
                (hidden ? ' info-box-padding' : '') +
                (sticky ? ' info-box-all' : '')
            }>
            <div className={'info-box-border flex' + (hidden ? ' hidden' : '')}>
                <span className="icon-info flex">
                    <SVGIcon id={'icon-information'} className={''} width={24} height={24} fill={''} />
                </span>
                <span className="title flex">
                    <Trans t={t}>{title}</Trans>
                    <span className="icon-delete flex" onClick={handleClickCloseBtn}>
                        <SVGIcon id={'icon-x'} className={'light-blue'} width={12} height={12} fill={'#006192'} />
                    </span>
                </span>
            </div>
        </div>
    )
}

export default InfoBox
